import z from "zod";
import { TipPresetButtonScheme } from "./tipSettings";

export const TipGridScheme = z.object({
  rows: z.number().int(),
  cols: z.number().int(),
  buttons: z.array(TipPresetButtonScheme),
});
